import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const ReusableTable = ({ tableConfig }) => {
  const { columns, data } = tableConfig;

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((column, colIndex) => (
              <TableCell key={column.id} align={colIndex === 0 ? 'left' : 'center'} sx={{ border: '1px solid #ddd', padding: '10px 16px' }}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              {columns.map((column, colIndex) => (
                <TableCell key={column.id} align={colIndex === 0 ? 'left' : 'center'} sx={{ border: '1px solid #ddd', padding: '10px 16px' }}>
                  {row[column.id]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReusableTable;
